import React, { useState, useEffect } from 'react';
import { useScroll } from '../hooks/useScroll';
import ThemeToggle from './ThemeToggle';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { scrollPercentage, isScrolled } = useScroll();
  const headerRef = React.useRef(null);

  useEffect(() => {
    if (headerRef.current) {
      headerRef.current.style.setProperty('--scroll-percentage', scrollPercentage);

      if (isScrolled) {
        headerRef.current.classList.add('scrolled');
        headerRef.current.classList.remove('not-scrolled');
      } else if (scrollPercentage > 0) {
        headerRef.current.classList.add('scrolling');
      } else {
        headerRef.current.classList.remove('scrolling', 'scrolled');
        headerRef.current.classList.add('not-scrolled');
      }
    }
  }, [scrollPercentage, isScrolled]);

  // Bloquear scroll do body quando o drawer estiver aberto
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.querySelector(targetId);
    if (target) {
      const headerHeight = headerRef.current?.offsetHeight || 0;
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="header" id="header" ref={headerRef}>
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <img src="/logo-alphatech.png" alt="Alpha Tech Logo" className="logo-img" />
          </div>
          <div className="nav-wrapper">
            <nav className={`nav ${isMenuOpen ? 'active' : ''}`} id="nav">
              <a href="#home" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#home')}>Início</a>
              <a href="#about" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#about')}>Sobre</a>
              <a href="#services" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#services')}>Serviços</a>
              <a href="#projects" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#projects')}>Projetos</a>
              <a href="#contact" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#contact')}>Contato</a>
            </nav>
          </div>
          {/* Drawer mobile - renderizado fora do nav-wrapper */}
          {isMenuOpen && (
            <nav className="nav mobile-drawer active" id="mobile-nav">
              <a href="#home" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#home')}>Início</a>
              <a href="#about" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#about')}>Sobre</a>
              <a href="#services" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#services')}>Serviços</a>
              <a href="#projects" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#projects')}>Projetos</a>
              <a href="#contact" className="nav-link" onClick={(e) => handleSmoothScroll(e, '#contact')}>Contato</a>
            </nav>
          )}
          <a href="#contact" className="btn-primary header-cta" onClick={(e) => handleSmoothScroll(e, '#contact')}>Fale Conosco</a>
          <ThemeToggle />
          <button
            className="mobile-menu-btn"
            id="mobileMenuBtn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
      {/* Overlay para fechar o drawer */}
      {isMenuOpen && (
        <div
          className="mobile-menu-overlay"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;

